const CODE_FENCE_LINE_PATTERN = /^\s*```/m;

export const hasMarkdownCodeFence = (content: string): boolean =>
  CODE_FENCE_LINE_PATTERN.test(content);
